// extracted by mini-css-extract-plugin
module.exports = {"dots":"dots_dots__e0bPc","regularDots":"dots_regularDots__1Wi_S","active":"dots_active__dN4oS","longDots":"dots_longDots__Nb5eQ","dynamicWidth":"dots_dynamicWidth__pA3rZ"};